export const INDEX_TYPE_WEB_CRAWLING = 'WEB_CRAWLING';
export const INDEX_TYPE_WEB_SCRAPING = 'WEB_SCRAPING';
export const INDEX_TYPE_PRESS_RELEASE = 'PRESS_RELEASE';
export const INDEX_TYPE_EVENT_CALENDAR = 'EVENT_CALENDAR';
export const FREQUENCY_EVERY_FOUR_HOURS = 'EVERY_FOUR_HOURS';
export const FREQUENCY_DAILY = 'DAILY';
export const FREQUENCY_WEEKLY = 'WEEKLY';
export const FREQUENCY_MONTHLY = 'MONTHLY';
export const FREQUENCY_EVERY_SIX_HOURS = 'EVERY_SIX_HOURS';
